import { Modal, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import TopBar from '../../components/Layout/TopBar';
import MyButton from '../../components/Layout/MyButton';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { ClipLoader } from 'react-spinners';
import { useAlert } from 'react-alert';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import { Editor } from 'react-draft-wysiwyg';
import SelectorTchatChannel from '../../components/AgGrid/SelectorTchatChannel';
import { CHANNEL_TYPE, PROFIL } from '../../constants/enum';
import {
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from '@mui/lab';
import moment from 'moment/moment';
import MarkAsUnreadIcon from '@mui/icons-material/MarkAsUnread';

const css = {
  modal: {
    height: '100%',
    width: '100%',
  },
  container: {
    height: '85%',
    width: '90%',
    backgroundColor: 'white',
    borderRadius: '5px',
    margin: 'auto',
  },
  fullRow: {
    height: '100%',
    width: '100%',
    alignItems: 'center',
  },
  row: {
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'normal',
  },
  rowValidation: {
    height: '60px',
    flexDirection: 'column',
    justifyContent: 'normal',
    alignItems: 'flex-end',
  },
  messengerContainer: {
    height: 'calc(100% - 50px)',
    backgroundColor: 'white',
    borderRadius: '5px',
    overflowY: 'hidden',
  },
  messageItemsContainer: {
    height: '90%',
    borderRadius: '5px',
    padding: '30px',
    overflowY: 'auto',
  },
  messageTextArea: {
    height: '40%',
  },
  messageItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  messageItemContent: {
    display: 'flex',
    maxWidth: '80%',
    position: 'relative',
  },
  messageOwner: {
    display: 'flex',
    color: 'white',
    fontSize: '24px',
    padding: '10px',
    margin: '10px',
    minWidth: '30px',
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  messageContent: {
    fontSize: '16px',
    paddingTop: '10px',
  },
  messageContentDescription: {
    fontSize: '18px',
    backgroundColor: '#e9e9e9',
    alignItems: 'center',
    padding: '20px',
    borderRadius: '16px',
    color: 'black',
    minWidth: '200px',
  },
  messageContentDate: {
    fontSize: '16px',
    marginTop: '5px',
  },
  messengerSendBtnContainer: {
    display: 'flex',
    width: '99%',
    justifyContent: 'flex-end',
    marginRight: '10px',
  },
};

const ModalViewMessages = (props) => {
  const { openModal, setOpenModal, color, dossier, user, profil } = props;
  const alert = useAlert();
  const [isLoading, setIsLoading] = useState(true);
  const [listMessage, setListMessage] = useState([]);
  //#region useEffect

  useEffect(() => {
    if (openModal) {
      apiGetMessages();
    }
  }, [openModal]);

  //#endregion

  //#region Functions

  const handleCloseModal = () => {
    setIsLoading(false);
    setOpenModal(false);
  };

  //#endregion

  //#region API

  const apiGetMessages = () => {
    axios({
      method: 'GET', url: `${URL_API}/messagerie/messages-no-reply`, params: { requestPassId: dossier.id },
    })
      .then((response) => {
        alert.removeAll();
        setListMessage(response.data);
        setIsLoading(false);

        if (response.data.length === 0) {
          alert.info('Aucun message n\'a été envoyé pour ce dossier');
        }
      })
      .catch((error) => {
        alert.removeAll();
        alert.error(error.message);
      });
  };


  function escapeHTML(htmlString) {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || "";
}
  //#endregion

  return (
    <Modal open={openModal} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
      <div className='modal' style={css.modal}>
        <div style={css.container}>
          <TopBar title={`Messages lié au dossier [N°${dossier.id}]`} className='topbar-contenu' color={'#a5c946'}
                  buttons={<div className='topbar-buttons'>
                    <MyButton onClick={() => handleCloseModal()} label='Fermer' icon={faXmark} sx={{backgroundColor: '#839d3c !important'}} />
                  </div>}
          />

          {isLoading && <div className='row' style={css.fullRow}>
            <ClipLoader color='#0094ca' loading={isLoading} size={75}
                        css={'display: flex; margin: 25px;justify-content: center;'} />
          </div>}

          {!isLoading && <div className='row' style={css.row}>
            <div className='messenger-container' style={css.messengerContainer}>
              <div className='message-items-container' style={css.messageItemsContainer}>
                {listMessage.length > 0 ? listMessage.map((message, index) => {
                  return (
                    <TimelineItem key={index}>
                      <TimelineOppositeContent sx={{ m: 'auto 0' }} align='right' variant='body2'>
                        <Typography variant='h6' component='span'>
                          {message.title}
                        </Typography><br />
                        {moment(message.date_message).format('DD/MM/YYYY à HH:mm')}
                      </TimelineOppositeContent>
                      <TimelineSeparator>
                        {index === 0 ? <></> : <TimelineConnector sx={{ bgcolor: '#ff0000', height: '30px' }} />}
                        <TimelineDot sx={{ bgcolor: '#ff0000', cursor: 'pointer' }}>
                          <MarkAsUnreadIcon />
                        </TimelineDot>
                        {index === (listMessage.length - 1) ? <></> :
                          <TimelineConnector sx={{ bgcolor: '#ff0000', height: '30px' }} />}
                      </TimelineSeparator>
                      <TimelineContent sx={{ m: 'auto' }} align='right' variant='body2'>
                        <Typography>{escapeHTML(message.message)}</Typography>
                      </TimelineContent>
                    </TimelineItem>
                  );
                }) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <Typography>Aucun message n'a été envoyé pour ce dossier</Typography>
                </div>}
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </Modal>
  );

};

export default ModalViewMessages;